export const URL_CALCULATOR =
  "http://dev.deasra.in/recalculate-price/?service_id=";
